<template>
  <router-view style="margin: 16px; background: white; padding: 32px; min-height: 95vh!important;"/>
</template>

<script>
export default {
  name: 'DefaultPage'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DefaultPage.vue